import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../../../scss/frontend/uniformSurvey.scss";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfirmYourInformationModal } from "../../../modal/ConfirmYourInformationModal";
import { InfoChartModal } from "../../../modal/InfoChartModal";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import UniformImage from "../../../components/font-end/UniformSurvey/UniformImage";
import {
  UniformBenefit,
  SaveSurvey,
  UniformLastest,
  GetUniformBenefitIncorrect,
  UniformGetSchedulers,
} from "../../../services/ApiUniformSurvey";
import {
  UniformBenefitType,
  ProfileSurveyType,
  UniformLatestType,
  uniform_survey_schedulers,
} from "../../../model/datatype";
import { ConfirmHandleErrorModal } from "../../../modal/ConfirmHandleErrorModal";
import { useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import parse from "html-react-parser";
import { useUserProfile } from "../../../contexts/UserProfileContext";
import { isTokenExpiredError } from "../../../utils/tokenUtils";
import {
  canEnterUniformSubmission,
  isScheduleViewOnly,
} from "../../../utils/uniformScheduleAccess";

export const SubmitUniformSurvey = (props: any) => {
  const { profile, loading: profileLoading } = useUserProfile();
  const [itemTumbler, setTumbler] = useState("");
  const [data, setData] = useState<ProfileSurveyType | null>(null);
  const [showErrorBody, setShowErrorBodyModal] = useState("");
  const [showError, setShowErrorModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [chartModal, setChartModal] = useState(false);
  const [show, setShow] = useState("none");
  const [notFoundType, setNotFoundType] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalConfrim, setShowModalComfrim] = useState(false);
  const [uniformtype, setUniformtype] = useState<UniformBenefitType | null>(
    null
  );
  const [uniformAmont, setUniformAmont] = useState(0);
  const [uniformImage, setUniformImage] = useState("");
  const [shirtGender, setShirtGender] = useState("");
  const [pantGender, setPantGender] = useState("");
  const [itemType, setItemType] = useState("");
  const [itemTypeTable, setItemTypeTable] = useState("");
  const [validdateData, setValidateData] = useState("");
  const [modalValidateShow, setModalValidateShow] = useState(false);
  const [uniformLastest, setUniformLastest] =
    useState<UniformLatestType | null>(null);
  const [itemSchedulers, setItemSchedulers] =
    useState<uniform_survey_schedulers | null>(null);
  const [checkOpen, setCheckOpen] = useState(true);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location: any = useLocation();

  const [DepartmentCode, setDepartmentCode] = useState(location.state);
  const [JobLevel, setJobLevel] = useState();
  const [biggerSizeShirt, setbiggerSizeShirt] = useState(false);
  const [biggerSizePant, setbiggerSizePant] = useState(false);
  const [biggerSizeDress, setbiggerSizeDress] = useState(false);
  const [biggerSizeSlipper, setbiggerSizeSlipper] = useState(false);
  const [biggerSizeBars, setbiggerSizeBars] = useState(false);
  const [barsChange, setBarsChange] = useState(false);
  const [shirtChange, setShirtChange] = useState(false);
  const [pantChange, setPantChange] = useState(false);
  const [dressChange, setDressChange] = useState(false);
  const [slipperChange, setSlipperChange] = useState(false);
  const [tumblerChange, setTumblerChange] = useState(false);

  // Utility function to normalize uniform type names to match actual filenames
  const normalizeUniformImageName = (uniformType: string) => {
    if (!uniformType) return uniformType;
    // Convert "Staff Pants" to "Staff pants" to match actual filename
    return uniformType.replace(/Pants/g, "pants");
  };

  const [searchParams, setSearchParams] = useSearchParams();

  // console.log("profile==>", props.profile);
  //console.log("location.state=>", location.state);
  // console.log('shirtGender=>', shirtGender);
  // console.log('pantGender=>', pantGender);
  const sizeMale = [
    { key: 26, value: 26 },
    { key: 28, value: 28 },
    { key: 30, value: 30 },
    { key: 32, value: 32 },
    { key: 34, value: 34 },
    { key: 36, value: 36 },
    { key: 38, value: 38 },
    { key: 40, value: 40 },
    { key: 42, value: 42 },
    { key: 44, value: 44 },
    { key: 46, value: 46 },
  ];

  const sizefeMale = [
    { key: 26, value: 26 },
    { key: 28, value: 28 },
    { key: 30, value: 30 },
    { key: 32, value: 32 },
    { key: 34, value: 34 },
    { key: 36, value: 36 },
    { key: 38, value: 38 },
    { key: 40, value: 40 },
  ];
  const sizeShirtAll = [
    { key: "SS", value: "SS" },
    { key: "S", value: "S" },
    { key: "M", value: "M" },
    { key: "L", value: "L" },
    { key: "XL", value: "XL" },
    { key: "XXL", value: "XXL" },
    { key: "3XL", value: "3XL" },
  ];

  const dressSizeList = [
    { key: 5, value: 5 },
    { key: 7, value: 7 },
    { key: 9, value: 9 },
    { key: 11, value: 11 },
    { key: 13, value: 13 },
    { key: 15, value: 15 },
    { key: 17, value: 17 },
    { key: 19, value: 19 },
    { key: 21, value: 21 },
    { key: 23, value: 23 },
  ];

  const flagCheck = true;
  const [surveys, setSurveys] = useState({
    jobLevel: JobLevel,
    employeeId: "",
    shirtType: undefined,
    shirtSizeDescription: "",
    shirtGender: "",
    shirtQty: null,
    pantGender: "",
    shirtSize: undefined,
    pantQty: null,
    pantSize: undefined,
    pantSizeDescription: "",
    dressQty: null,
    dressSize: undefined,
    dressSizeDescription: "",
    slipperQty: null,
    slipperSize: undefined,
    slipperSizeDescription: "",
    braQty: null,
    braSize: undefined,
    braSizeDescription: "",
    tumblerQty: null,
    tumblerType: undefined,
    sex: "",
    uniformSurveyExtensions: [
      {
        employeeId: "",
        costCenter: "",
        jobLevel: "",
        shirtType: "",
        employeeType: "",
        uniformType: "",
        acceptedConsent: "",
        originAmount: 0,
        selectedAmount: 0,
      },
    ],
  });
  const splitText = (text: any, number: number) => {
    //console.log('text',text);
    if (typeof text !== "undefined" && text !== null) {
      const site = text.split("(");
      //console.log('splitText',site[number])
      return site[number];
    }
  };
  const splitTextAfter = (text: any) => {
    if (typeof text !== "undefined" && text !== null) {
      const site1 = text.split("(");
      const site2 = site1[1].split(")");
      return site2[0];
    }
  };
  useEffect(() => {
    UniformGetSchedulers()
      .then((response) => {
        setItemSchedulers(response);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (itemSchedulers === null || profileLoading) return;
    if (!canEnterUniformSubmission(itemSchedulers)) {
      navigate("/", { replace: true });
    }
  }, [itemSchedulers, navigate, profileLoading]);

  useEffect(() => {
    if (profileLoading) return;
    if (!profile) return;
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    //console.log("params.setType=", params);
    const responseData = profile;

    UniformLastest()
      .then((response) => {
        //console.log("getUniform=", response);
        //console.log("response.braSize=", typeof response?.braSize);

        if (response?.braSize != null && response?.braSize != "Decline") {
          setBarsChange(true);
        }

        if (response.braSize !== null && response.braSize != "Decline") {
          setBarsChange(true);
        }

        if (response.shirtSize !== null && response.shirtSize != "Decline") {
          setShirtChange(true);
        }

        if (response.shirtSize === "Bigger than normal size") {
          setbiggerSizeShirt(true);
          //setShirtChange(true);
        }

        if (response.pantSize !== null && response.pantSize != "Decline") {
          setPantChange(true);
        }

        if (response.pantSize === "Bigger than normal size") {
          setbiggerSizePant(true);
          //setPantChange(true);
        }

        if (response.dressSize !== null && response.dressSize != "Decline") {
          setDressChange(true);
        }

        if (response.dressSize === "Bigger than normal size") {
          setbiggerSizeDress(true);
          //setDressChange(true);
        }

        if (
          response.slipperSize !== null &&
          response.slipperSize != "Decline"
        ) {
          setSlipperChange(true);
        }

        if (
          response.tumblerType !== null &&
          response.tumblerType != "Decline"
        ) {
          setTumblerChange(true);
        }

        if (response.slipperSize === "Bigger than normal size") {
          setbiggerSizeSlipper(true);
          //setSlipperChange(true);
        }
        if (response.braSize === "Bigger than normal size") {
          setbiggerSizeBars(true);
        }
        setUniformLastest(response);
        setShirtGender(response.shirtGender);
        setPantGender(response.pantGender);

        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["shirtSize"]: response.shirtSize,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["shirtSizeDescription"]: response.shirtSizeDescription,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["shirtGender"]: response.shirtGender,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["pantSize"]: response.pantSize,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["pantSizeDescription"]: response.pantSizeDescription,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["pantGender"]: response.pantGender,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["dressSize"]: response.dressSize,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["dressSizeDescription"]: response.dressSizeDescription,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["slipperSize"]: response.slipperSize,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["slipperSizeDescription"]: response.slipperSizeDescription,
        }));
        // setSurveys((oldValues: any) => ({
        //   ...oldValues,
        //   ["braSize"]:response?.braSize,
        // }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["braSize"]:
            response?.braSize === null &&
            responseData?.gender === "Male" &&
            !barsChange
              ? "Decline"
              : response.braSize,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["braSizeDescription"]: response.braSizeDescription,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["tumblerType"]: response.tumblerType,
        }));

        //uniformSurveyExtensions
      })
      .catch((error: any) => {
        if (isTokenExpiredError(error)) {
          // API layer will handle redirect
        }
      });

    // console.log('responseData=',responseData);
    const getData: any = responseData;
    setData(getData);
    setDepartmentCode(location.state);
    GetUniformBenefitIncorrect(DepartmentCode)
      .then((response) => {
        if (!response) {
          setNotFoundType(true);
        }
        //console.log("GetUniformBenefitIncorrect=", response);
        setJobLevel(response.jobLevel);
        setUniformtype(response);
        const total =
          response.shirtQty +
          response.pantsQty +
          response.slipperQty +
          response.tumblerQty +
          response.dressQty +
          response.braQty;
        setUniformAmont(total);
        setUniformImage(response.shirtType);
        //console.log("Resp uniform type==>", response);

        // setShirtGender('Male')

         setSurveys((oldValues) => ({
              ...oldValues,
              uniformSurveyExtensions: oldValues.uniformSurveyExtensions.map(
                (extension, index) =>
                  index === 0
                    ? {
                        ...extension,
                        employeeId: responseData?.employeeId,
                        costCenter: DepartmentCode.departmentCode,
                        jobLevel: response.jobLevel,
                        shirtType: response.shirtType,
                        employeeType: response.jobLevel,
                        uniformType: response.shirtType,
                        acceptedConsent:
                          DepartmentCode?.departmentCodeFull?.selectedAmount ===
                          1
                            ? "yes"
                            : DepartmentCode?.departmentCodeFull?.policyset,
                        originAmount: DepartmentCode?.departmentCodeFull
                          ?.originAmount
                          ? DepartmentCode?.departmentCodeFull?.originAmount
                          : location.state.originAmount,
                        selectedAmount: location.state.selectedAmount,
                      }
                    : extension
              ),
            }));

        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["employeeId"]: responseData?.employeeId,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["jobLevel"]: response.jobLevel,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["shirtType"]: response.shirtType,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["shirtQty"]: response.shirtQty,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["pantQty"]: response.pantsQty,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["slipperQty"]: response.slipperQty,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["tumblerQty"]: response.tumblerQty,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["dressQty"]: response.dressQty,
        }));
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["braQty"]: response.braQty,
        }));
        // setSurveys((oldValues: any) => ({
        //   ...oldValues,
        //   ["braSize"]: response.braSize,
        // }));
      })
      .catch((error: any) => {
        if (isTokenExpiredError(error)) {
          // API layer will handle redirect
        }
      });
  }, [profileLoading, profile]);

  //console.log("searchParams=", searchParams.get("setType"));
  //alert(barsChange);

  // console.log('uniformLastest=', uniformLastest);
  // console.log('surveys', surveys)
  //console.log("uniformtype=", uniformtype);

  // request_note_shirts: 'ป้อนรายละเอียดเพิ่มเติมเสื้อ',
  // request_note_pants: 'ป้อนรายละเอียดเพิ่มเติมกางเกง',
  // request_note_dress: 'ป้อนรายละเอียดเพิ่มเติมชุดประโปรง',
  // request_note_slippers: 'ป้อนรายละเอียดเพิ่มเติมรองเท้าเตะ',
  // request_note_bars: 'ป้อนรายละเอียดเพิ่มเติมชุดชั้นใน',

  const handleErrorOpen = () => {
    setShowErrorModal(true);
  };

  const handleErrorClose = () => {
    setShowErrorModal(false);
  };
  const ValidateForm = () => {
    //console.log("ValicateForom=", surveys);
    let shirtValidate = "";
    let pantValidate = "";
    let dressValidate = "";
    let slipperValidate = "";
    let brasValidate = "";
    let tumlerTypeValidate = "";
    let ValidateMsg = "";
    let shirtGenderMessage = "";
    let pantsGenderMessage = "";
    let shirtSizeDescriptionMessage = "";
    let pantSizeDescriptionMessage = "";
    let dressSizeDescriptionMessage = "";
    let barSizeDescriptionMessage = "";
    let slipperSizeDescriptionMessage = "";
    // console.log("ValidateForm==>", surveys);
    // console.log("ValidateFormshirtGender==>", shirtGender);
    // console.log("ValidateFormPantGender==>", pantGender);

    if (surveys.shirtQty !== null && !surveys.shirtSize) {
      shirtValidate =
        "<li>" +
        t("uniform_survey.request_message.request_shirts_message") +
        "</li>";
    }
    if (
      surveys.shirtQty !== null &&
      surveys.shirtSize === "Bigger than normal size" &&
      !surveys.shirtSizeDescription
    ) {
      shirtSizeDescriptionMessage =
        "<li>" +
        t("uniform_survey.request_message.request_note_shirts") +
        "</li>";
    }

    if (
      surveys.pantQty !== null &&
      surveys.pantSize === "Bigger than normal size" &&
      !surveys.pantSizeDescription
    ) {
      pantSizeDescriptionMessage =
        "<li>" +
        t("uniform_survey.request_message.request_note_pants") +
        "</li>";
    }

    if (
      surveys.dressQty !== null &&
      surveys.dressSize === "Bigger than normal size" &&
      !surveys.dressSizeDescription
    ) {
      dressSizeDescriptionMessage =
        "<li>" +
        t("uniform_survey.request_message.request_note_dress") +
        "</li>";
    }

    if (
      (surveys.braQty !== null &&
        surveys.braSize === "Bigger than normal size" &&
        surveys.braSizeDescription == null) ||
      (surveys.braQty !== null &&
        surveys.braSize === "Bigger than normal size" &&
        surveys.braSizeDescription == "")
    ) {
      barSizeDescriptionMessage =
        "<li>" +
        t("uniform_survey.request_message.request_note_bars") +
        "</li>";
    }

    if (
      surveys.slipperQty !== null &&
      surveys.slipperSize === "Bigger than normal size" &&
      !surveys.slipperSizeDescription
    ) {
      slipperSizeDescriptionMessage =
        "<li>" +
        t("uniform_survey.request_message.request_note_slippers") +
        "</li>";
    }

    if (surveys.shirtQty !== null && !shirtGender) {
      shirtGenderMessage =
        "<li>" +
        t("uniform_survey.request_message.request_gender_shirts") +
        "</li>";
    }

    if (surveys.pantQty !== null && !surveys.pantSize) {
      pantValidate =
        "<li>" +
        t("uniform_survey.request_message.request_pants_message") +
        "</li>";
    }

    if (surveys.pantQty !== null && !pantGender) {
      pantsGenderMessage =
        "<li>" +
        t("uniform_survey.request_message.request_gender_pants") +
        "</li>";
    }

    if (surveys.dressQty !== null && !surveys.dressSize) {
      dressValidate =
        "<li>" +
        t("uniform_survey.request_message.request_dresses_message") +
        "</li>";
    }
    if (surveys.slipperQty !== null && !surveys.slipperSize) {
      slipperValidate =
        "<li>" +
        t("uniform_survey.request_message.request_slippers_message") +
        "</li>";
    }
    if (
      surveys.braQty !== null &&
      uniformtype?.employeeInfo?.gender == "Female" &&
      !surveys.braSize
    ) {
      brasValidate =
        "<li>" +
        t("uniform_survey.request_message.request_bras_message") +
        "</li>";
    }
    if (surveys.tumblerQty !== null && !surveys.tumblerType) {
      tumlerTypeValidate =
        "<li>" +
        t("uniform_survey.request_message.request_tumbler_message") +
        "</li>";
    }

    ValidateMsg =
      shirtGenderMessage +
      shirtSizeDescriptionMessage +
      pantSizeDescriptionMessage +
      dressSizeDescriptionMessage +
      barSizeDescriptionMessage +
      slipperSizeDescriptionMessage +
      shirtValidate +
      pantsGenderMessage +
      pantValidate +
      dressValidate +
      slipperValidate +
      brasValidate +
      tumlerTypeValidate;
    return ValidateMsg;
  };
  const handleOpen = () => {
    if (!canEnterUniformSubmission(itemSchedulers)) {
      navigate("/", { replace: true });
      return;
    }
    const valid: string = ValidateForm();
    setValidateData(valid);
    if (valid === "") {
      //if(checkOpen){
      // setCheckOpen(false)
      // console.log('open=shirtGender=>', shirtGender)
      // console.log('open=pantGender=>', pantGender)
      //    setSurveys((oldValues: any) => ({ ...oldValues, ['shirtSize']: surveys.shirtSize + '(' + shirtGender + ')' }));
      //    setSurveys((oldValues: any) => ({ ...oldValues, ['pantSize']: surveys.pantSize + '(' + pantGender + ')' }));
      // }

      setShowModal(true);
    } else {
      setModalValidateShow(true);
    }

    //console.log("Survey==>", surveys);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleChartOpen = (item: string, type: string) => {
    let validateChart = true;
    // alert(shirtGender);
    // alert(pantGender);
    if (item === "shirt" && shirtGender === undefined) {
      validateChart = false;
      return Swal.fire({
        icon: "error",
        title: t("uniform_survey.choose_uniform.choose_message.title"),
        text: t("uniform_survey.request_message.request_gender_shirts"),
      });
    }

    if (item === "pants" && pantGender === undefined) {
      validateChart = false;
      return Swal.fire({
        icon: "error",
        title: t("uniform_survey.choose_uniform.choose_message.title"),
        text: t("uniform_survey.request_message.request_gender_pants"),
      });
    }

    if (validateChart) {
      setItemType(item);
      setItemTypeTable(type);
      setChartModal(true);
    }
  };

  const handleChartClose = () => {
    setChartModal(false);
  };

  const handleStartSurvey = () => {
    setShowModalComfrim(true);
  };

  const handleErrorYes = () => {
    setShowModal(true);
    setShowErrorModal(false);
  };

  const handleErrorNo = () => {
    setShowModal(true);
    setShowErrorModal(false);
  };

  const handleYes = () => {
    if (!canEnterUniformSubmission(itemSchedulers)) {
      setShowModal(false);
      navigate("/", { replace: true });
      return;
    }
    //console.log("surveysSave=", surveys);
    //return false;
    setIsLoading(true);
    SaveSurvey(surveys)
      .then((response) => {
        //  console.log(response);
        const getData: any = response;
        setIsLoading(false);
        navigate("/successfully");
      })
      .catch((error: any) => {
        setIsLoading(false);
        
        // ตรวจสอบว่าเป็น token expiration error หรือไม่
        if (isTokenExpiredError(error)) {
          Swal.fire({
            icon: "warning",
            title: "Session Expired",
            text: "Your session has expired. Please login again.",
            confirmButtonText: "Login",
            allowOutsideClick: false,
          }).then(() => {
            // Token expiration จะถูกจัดการใน API layer อยู่แล้ว
            // แต่เผื่อไว้ในกรณีที่ต้องการทำอะไรเพิ่มเติม
            window.location.href = "/";
          });
          return;
        }
        
        setShowErrorBodyModal(error);
        setShowErrorModal(true);
        setShowModal(false);
        //   console.log('error=', error);
      });
  };

  const setInputSizeValue = (e: any) => {
    const { name, value } = e.target;
    // console.log('name=', name);
    // console.log('value=', value);

    if (name === "shirtSize") {
      if (value === "Decline") {
        setShirtChange(false);
        setbiggerSizeShirt(false);
      } else if (value === "Bigger than normal size") {
        setShirtChange(true);
        setbiggerSizeShirt(true);
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["shirtSizeDescription"]: uniformLastest?.shirtSizeDescription,
        }));
      } else {
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["shirtSizeDescription"]: "",
        }));
        setbiggerSizeShirt(false);
        setShirtChange(true);
      }
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else if (name === "pantSize") {
      if (value === "Decline") {
        setPantChange(false);
        setbiggerSizePant(false);
      } else if (value === "Bigger than normal size") {
        setPantChange(true);
        setbiggerSizePant(true);
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["pantSizeDescription"]: uniformLastest?.pantSizeDescription,
        }));
      } else {
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["pantSizeDescription"]: "",
        }));
        setbiggerSizePant(false);
        setPantChange(true);
      }
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else if (name == "dressSize") {
      if (value === "Decline") {
        setDressChange(false);
        setbiggerSizeDress(false);
      } else if (value === "Bigger than normal size") {
        setbiggerSizeDress(true);
        setDressChange(true);
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["dressSizeDescription"]: uniformLastest?.dressSizeDescription,
        }));
      } else {
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["dressSizeDescription"]: "",
        }));
        setbiggerSizeDress(false);
        setDressChange(true);
      }
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else if (name == "braSize") {
      if (value === "Decline") {
        setBarsChange(false);
        setbiggerSizeBars(false);
      } else if (value === "Bigger than normal size") {
        setbiggerSizeBars(true);
        setBarsChange(true);
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["braSizeDescription"]: uniformLastest?.braSizeDescription,
        }));
      } else {
        setBarsChange(true);
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["braSizeDescription"]: "",
        }));
        setbiggerSizeBars(false);
      }
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else if (name === "slipperSize") {
      if (value === "Decline") {
        setSlipperChange(false);
        setbiggerSizeSlipper(false);
      } else if (value === "Bigger than normal size") {
        setbiggerSizeSlipper(true);
        setSlipperChange(true);
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["SlipperSizeDescription"]: uniformLastest?.slipperSizeDescription,
        }));
      } else {
        setSurveys((oldValues: any) => ({
          ...oldValues,
          ["SlipperSizeDescription"]: "",
        }));
        setbiggerSizeSlipper(false);
        setSlipperChange(true);
      }
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    }
    if (name === "gender-shirt") {
      setShirtGender(value);
      setSurveys((oldValues: any) => ({
        ...oldValues,
        ["shirtSize"]: surveys?.shirtSize,
      }));
      setSurveys((oldValues: any) => ({
        ...oldValues,
        ["shirtGender"]: value,
      }));
    } else if (name === "gender-pants") {
      setPantGender(value);
      setSurveys((oldValues: any) => ({
        ...oldValues,
        ["pantSize"]: surveys?.pantSize,
      }));
      setSurveys((oldValues: any) => ({ ...oldValues, ["pantGender"]: value }));
    } else if (name === "tumblerType") {
      if (value === "Decline") {
        setTumblerChange(false);
      } else {
        setTumblerChange(true);
      }
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    } else {
      setSurveys((oldValues: any) => ({ ...oldValues, [name]: value }));
    }

    //console.log("onChagne=", surveys);
  };

  interface ValidateFormModalProps {
    show: boolean;
    message: string;
    onHide: () => void;
  }

  function ValidateFormModal(props: ValidateFormModalProps) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-modal-confirm uniformModel validaform"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("uniform_survey.request_message.request_title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <ul>{parse(props.message)}</ul>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-yes  " onClick={props.onHide}>
            {t("uniform_survey.error_message.btn_no")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const isViewOnlySchedule = isScheduleViewOnly(itemSchedulers);

  return (
    <>
      <ConfirmHandleErrorModal
        showModal={showError}
        handleContinue={handleErrorClose}
        click_no={handleErrorNo}
        errorMessage={showErrorBody}
        click_yes={handleErrorYes}
      />

      <InfoChartModal
        showModal={chartModal}
        handleContinue={handleChartClose}
        cancel={handleChartClose}
        click_yes=""
        shirtGender={shirtGender}
        pantGender={pantGender}
        itemtype={itemType}
        itemTypeTable={itemTypeTable}
      />

      <ConfirmYourInformationModal
        showModal={showModal}
        handleContinue={handleClose}
        cancel={handleClose}
        click_yes={handleYes}
        benefit={uniformtype}
        surveys={surveys}
        shirtGender={shirtGender}
        pantGender={pantGender}
        uniformImage={uniformImage}
        isLoading={isLoading}
      />

      <div
        className="uniform-survey-info listItem full-screen-box-item"
        style={{ top: "auto" }}
      >
        <Container className="">
          <Row>
            <Col xs={2} md={1} lg={1} className="p-0 m-0">
              <div className="bg-cicle-title">
                <a href="/">
                  <img
                    src="../images/UniformSurvey.png"
                    alt="UniformSurvey"
                    width={40}
                    className="mt-1"
                  />
                </a>
              </div>
            </Col>
            <Col xs={4} md={4} lg={7} className="p-0">
              <div className="uniform-select-title">
                {t("uniform_survey.choose_uniform.title")}
              </div>
            </Col>
            <Col xs={6} md={6} lg={4} className="text-end mt-1 px-0">
              {!notFoundType && !isViewOnlySchedule ? (
                <>
                  <Button
                    className="btn-check-survey"
                    onClick={() => handleOpen()}
                  >
                    {t("uniform_survey.choose_uniform.btn_sumbit_uniform")}
                  </Button>
                </>
              ) : (
                <></>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <hr className="mt-2 pt-1 mb-1" />
            </Col>
          </Row>

          {uniformtype ? (
            <>
              <Row>
                <Col>
                  <div className="text-danger">
                    {t("uniform_survey.choose_uniform.messages_alert_big_size")}
                  </div>
                </Col>
              </Row>
              {uniformtype && uniformtype?.shirtQty != null ? (
                <Row>
                  <Col
                    xs={4}
                    md={2}
                    lg={2}
                    className="uniform-item m-0 p-0"
                    onClick={() =>
                      handleChartOpen("shirt", uniformtype.shirtType)
                    }
                  >
                    <UniformImage
                      imagesName={uniformImage}
                      size="sm"
                      customSize={100}
                    />
                    {/* <img
                      src={uniformImage}
                      alt="UniformSurvey"
                      className=" m-2 mb-2 item-shadow rounded border"
                      width={100}
                    /> */}
                    <div className="size-chart">
                      <img
                        src="../images/pie-chart.png"
                        alt="chart-icon"
                        className="img-uniform"
                      />
                      <label className="size-chart-title">
                        {t("uniform_survey.choose_uniform.size_chart")}
                      </label>
                    </div>
                  </Col>
                  <Col xs={7} md={8} lg={8} className="pt-2">
                    <div className="choose-show font-wiegth-bold mb-2">
                      {localStorage.getItem("Language") === "en"
                        ? uniformtype?.shirtDescriptionEn
                        : uniformtype?.shirtDescriptionTh}
                    </div>
                    <div>
                      <Form.Check
                        className="choose-gender-check"
                        inline
                        checked={shirtGender === "Male" ? true : false}
                        label={t("uniform_survey.choose_uniform.male")}
                        name="gender-shirt"
                        type="radio"
                        value="Male"
                        id={`inline-radio-1`}
                        onChange={(e: any) => setInputSizeValue(e)}
                      />
                      <Form.Check
                        className="choose-gender-check"
                        inline
                        label={t("uniform_survey.choose_uniform.female")}
                        checked={shirtGender === "Female" ? true : false}
                        name="gender-shirt"
                        type="radio"
                        value="Female"
                        id={`inline-radio-2`}
                        onChange={(e: any) => setInputSizeValue(e)}
                      />
                    </div>
                    <div>
                      <Form.Select
                        as="select"
                        value={surveys.shirtSize}
                        className={`mt-2 mb-2 ${
                          validdateData !== "" &&
                          surveys.shirtSize === undefined
                            ? "require"
                            : ""
                        }`}
                        size="sm"
                        name="shirtSize"
                        onChange={(e: any) => setInputSizeValue(e)}
                      >
                        <option value="">
                          {t("uniform_survey.choose_uniform.select_size")}
                        </option>
                        {sizeShirtAll.map((item: any, index: number) => (
                          <option value={item.key} key={index}>
                            {item.value}
                          </option>
                        ))}
                        <option value="Bigger than normal size">
                          {t("uniform_survey.choose_uniform.big_size")}
                        </option>
                        <option value="Decline">
                          {t("uniform_survey.choose_uniform.no_receive")}
                        </option>
                      </Form.Select>
                      {biggerSizeShirt ? (
                        <>
                          <input
                            type="text"
                            className={`form-control mt-0 pt-1 ${
                              (validdateData !== "" &&
                                surveys.shirtSizeDescription == null) ||
                              surveys.shirtSizeDescription == ""
                                ? "require"
                                : ""
                            }`}
                            placeholder={t(
                              "uniform_survey.request_message.request_note_message"
                            )}
                            name="shirtSizeDescription"
                            value={surveys.shirtSizeDescription}
                            onChange={(e: any) => setInputSizeValue(e)}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="p-2">
                    <div className="text-center font-wiegth-bold">
                      {shirtChange ? uniformtype?.shirtQty : <>0</>}
                      {/* {uniformtype?.shirtQty} */}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.pantsQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() =>
                        handleChartOpen("pants", uniformtype.pantsType)
                      }
                    >
                      <img
                        src={`../images/uniform/${encodeURIComponent(
                          normalizeUniformImageName(uniformtype.pantsType)
                        )}.png`}
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                        height={140}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t("uniform_survey.choose_uniform.size_chart")}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      {localStorage.getItem("Language") === "en" ? (
                        <>
                          {uniformtype.shirtType === "Maintenance" ||
                          uniformtype.shirtType === "Driver Shirt"
                            ? uniformtype?.pantsDescriptionEn
                            : uniformtype?.pantsDescriptionEn}
                        </>
                      ) : (
                        <>
                          {uniformtype.shirtType === "Maintenance" ||
                          uniformtype.shirtType === "Driver Shirt"
                            ? uniformtype?.pantsDescriptionTh
                            : uniformtype?.pantsDescriptionTh}
                        </>
                      )}
                      <div>
                        <Form.Check
                          className="choose-gender-check"
                          inline
                          checked={pantGender === "Male" ? true : false}
                          label={t("uniform_survey.choose_uniform.male")}
                          name="gender-pants"
                          type="radio"
                          value="Male"
                          id={`inline-radio-3`}
                          onChange={(e: any) => setInputSizeValue(e)}
                        />
                        <Form.Check
                          className="choose-gender-check"
                          inline
                          checked={pantGender === "Female" ? true : false}
                          label={t("uniform_survey.choose_uniform.female")}
                          name="gender-pants"
                          type="radio"
                          value="Female"
                          id={`inline-radio-4`}
                          onChange={(e: any) => setInputSizeValue(e)}
                        />
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.pantSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== "" &&
                            surveys.pantSize === undefined
                              ? "require"
                              : ""
                          }`}
                          size="sm"
                          name="pantSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t("uniform_survey.choose_uniform.select_size")}
                          </option>
                          {pantGender === "Male"
                            ? sizeMale.map((item: any, index: number) => (
                                <option value={item.key} key={index}>
                                  {item.value}"
                                </option>
                              ))
                            : sizefeMale.map((item: any, index: number) => (
                                <option value={item.key} key={index}>
                                  {item.value}"
                                </option>
                              ))}
                          <option value="Bigger than normal size">
                            {t("uniform_survey.choose_uniform.big_size")}
                          </option>
                          <option value="Decline">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </option>
                        </Form.Select>
                        {biggerSizePant ? (
                          <>
                            <input
                              type="text"
                              className={`form-control mt-0 pt-1 ${
                                (validdateData !== "" &&
                                  surveys.pantSizeDescription == null) ||
                                surveys.pantSizeDescription == ""
                                  ? "require"
                                  : ""
                              }`}
                              placeholder={t(
                                "uniform_survey.request_message.request_note_message"
                              )}
                              name="pantSizeDescription"
                              value={surveys.pantSizeDescription}
                              onChange={(e: any) => setInputSizeValue(e)}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {pantChange ? uniformtype?.pantsQty : <>0</>}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.dressQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() =>
                        handleChartOpen("dress", uniformtype.dressDescriptionEn)
                      }
                    >
                      <img
                        src="../images/uniform/dress.png"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t("uniform_survey.choose_uniform.size_chart")}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {localStorage.getItem("Language") === "en"
                          ? uniformtype?.dressDescriptionEn
                          : uniformtype?.dressDescriptionTh}
                      </div>

                      <div>
                        <Form.Select
                          value={surveys.dressSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== "" &&
                            surveys.dressSize === undefined
                              ? "require"
                              : ""
                          }`}
                          size="sm"
                          name="dressSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t("uniform_survey.choose_uniform.select_size")}
                          </option>
                          {dressSizeList.map((item: any, index: number) => (
                            <option value={item.key} key={index}>
                              {item.value}''
                            </option>
                          ))}
                          <option value="Bigger than normal size">
                            {t("uniform_survey.choose_uniform.big_size")}
                          </option>
                          <option value="Decline">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </option>
                        </Form.Select>
                        {biggerSizeDress ? (
                          <>
                            <input
                              type="text"
                              className={`form-control mt-0 pt-1 ${
                                (validdateData !== "" &&
                                  surveys.dressSizeDescription == null) ||
                                surveys.dressSizeDescription == ""
                                  ? "require"
                                  : ""
                              }`}
                              placeholder={t(
                                "uniform_survey.request_message.request_note_message"
                              )}
                              name="dressSizeDescription"
                              value={surveys.dressSizeDescription}
                              onChange={(e: any) => setInputSizeValue(e)}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {dressChange ? uniformtype?.dressQty : <>0</>}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.braQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() =>
                        handleChartOpen("bras", uniformtype.braDescriptionEn)
                      }
                    >
                      <img
                        src="../images/uniform/bras.png"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t("uniform_survey.choose_uniform.size_chart")}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {uniformtype?.employeeInfo?.gender == "Male" ? (
                          <>
                            Bras (
                            {t(
                              "uniform_survey.your_uniform.infoUniform.IfNeeded"
                            )}
                            )
                          </>
                        ) : (
                          <>
                            {localStorage.getItem("Language") === "en"
                              ? uniformtype?.braDescriptionEn
                              : uniformtype?.braDescriptionTh}
                          </>
                        )}
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.braSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== "" &&
                            uniformtype?.employeeInfo?.gender !== "Male" &&
                            surveys.braSize === undefined
                              ? "require"
                              : ""
                          }`}
                          size="sm"
                          name="braSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          {/* {uniformtype?.employeeInfo?.gender !== "Male" ? (
                            <option value="">
                              {t("uniform_survey.choose_uniform.select_size")}
                            </option>
                          ) : (
                            <option value="Decline">
                              {t("uniform_survey.choose_uniform.no_receive")}
                            </option>
                          )} */}
                          <option value="">
                            {t("uniform_survey.choose_uniform.select_size")}
                          </option>

                          <option value="B 65/30">B 65/30</option>
                          <option value="B 70/32">B 70/32</option>
                          <option value="B 75/34">B 75/34</option>
                          <option value="B 80/36">B 80/36</option>
                          <option value="B 85/38">B 85/38</option>
                          <option value="B 90/40">B 90/40</option>
                          <option value="B 95/42">B 95/42</option>
                          <option value="Bigger than normal size">
                            {t("uniform_survey.choose_uniform.big_size")}
                          </option>
                          {uniformtype?.employeeInfo?.gender === "Male" ? (
                            <option value="Decline">
                              {t("uniform_survey.choose_uniform.no_receive")}
                            </option>
                          ) : (
                            <></>
                          )}
                          {uniformtype?.employeeInfo?.gender !== "Male" ? (
                            <option value="Decline">
                              {t("uniform_survey.choose_uniform.no_receive")}
                            </option>
                          ) : (
                            <></>
                          )}
                        </Form.Select>
                        {biggerSizeBars ? (
                          <>
                            <input
                              type="text"
                              className={`form-control mt-0 pt-1 ${
                                (validdateData !== "" &&
                                  surveys.braSizeDescription == null) ||
                                surveys.braSizeDescription == ""
                                  ? "require"
                                  : ""
                              }`}
                              placeholder={t(
                                "uniform_survey.request_message.request_note_message"
                              )}
                              name="braSizeDescription"
                              value={surveys.braSizeDescription}
                              onChange={(e: any) => setInputSizeValue(e)}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {barsChange ? uniformtype?.braQty : 0}
                        {/* {barsChange} */}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="bra-remark-message">
                        {t("uniform_survey.choose_uniform.BarMessage")}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.slipperQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={4}
                      md={2}
                      lg={2}
                      className="uniform-item m-0 p-0"
                      onClick={() =>
                        handleChartOpen(
                          "slippers",
                          uniformtype.slipperDescriptionEn
                        )
                      }
                    >
                      <img
                        src="../images/uniform/slippers.png"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                      <div className="size-chart">
                        <img
                          src="../images/pie-chart.png"
                          alt="chart-icon"
                          className="img-uniform"
                        />
                        <label className="size-chart-title">
                          {t("uniform_survey.choose_uniform.size_chart")}
                        </label>
                      </div>
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {localStorage.getItem("Language") === "en"
                          ? uniformtype?.slipperDescriptionEn
                          : uniformtype?.slipperDescriptionTh}
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.slipperSize}
                          className={`mt-2 mb-3 ${
                            validdateData !== "" &&
                            surveys.slipperSize === undefined
                              ? "require"
                              : ""
                          }`}
                          size="sm"
                          name="slipperSize"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t("uniform_survey.choose_uniform.select_size")}
                          </option>
                          <option value="9">9</option>
                          <option value="9.5">9.5</option>
                          <option value="10">10</option>
                          <option value="10.5">10.5</option>
                          <option value="11">11</option>
                          <option value="11.5">11.5</option>
                          <option value="Bigger than normal size">
                            {t("uniform_survey.choose_uniform.big_size")}
                          </option>
                          <option value="Decline">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </option>
                        </Form.Select>
                        {biggerSizeSlipper ? (
                          <>
                            <input
                              type="text"
                              className={`form-control mt-0 pt-1 ${
                                validdateData !== "" &&
                                surveys.slipperSizeDescription === undefined
                                  ? "require"
                                  : ""
                              }`}
                              placeholder={t(
                                "uniform_survey.request_message.request_note_message"
                              )}
                              name="slipperSizeDescription"
                              value={surveys.slipperSizeDescription}
                              onChange={(e: any) => setInputSizeValue(e)}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {slipperChange ? uniformtype?.slipperQty : <>0</>}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              {uniformtype && uniformtype?.tumblerQty != null ? (
                <>
                  <Row>
                    <Col>
                      <hr className="mt-2 pt-1 mb-1" />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4} md={2} lg={2} className="uniform-item m-0 p-0">
                      <img
                        src="../images/uniform/tumbler.png?a1"
                        alt="UniformSurvey"
                        className="m-2 mb-2 item-shadow rounded border"
                        width={100}
                      />
                    </Col>
                    <Col xs={7} md={8} lg={8} className="pt-2">
                      <div className="choose-show font-wiegth-bold mb-2">
                        {localStorage.getItem("Language") === "en"
                          ? uniformtype?.tumblerDescriptionEn
                          : uniformtype?.tumblerDescriptionTh}
                      </div>
                      <div>
                        <Form.Select
                          value={surveys.tumblerType}
                          className={`mt-2 mb-3 ${
                            validdateData !== "" &&
                            surveys.tumblerType == undefined
                              ? "require"
                              : ""
                          }`}
                          size="sm"
                          name="tumblerType"
                          onChange={(e: any) => setInputSizeValue(e)}
                        >
                          <option value="">
                            {t("uniform_survey.choose_uniform.select_tumbler")}
                          </option>
                          <option value="Accept">
                            {t("uniform_survey.choose_uniform.receive")}
                          </option>
                          <option value="Decline">
                            {t("uniform_survey.choose_uniform.no_receive")}
                          </option>
                        </Form.Select>
                      </div>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="p-2">
                      <div className="text-center font-wiegth-bold">
                        {tumblerChange ? uniformtype?.tumblerQty : <>0</>}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              <Row style={{ height: "200px" }}>
                <Col
                  className="text-center w-100 d-flex align-items-center justify-content-center"
                  lg={12}
                >
                  {notFoundType ? (
                    <>
                      <div className="text-danger"> {t("text_notfound")}</div>
                    </>
                  ) : (
                    <>
                      <div className="uniform-load">
                        <div className="uniform-load loader"></div>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            </>
          )}
        </Container>
      </div>
      <ValidateFormModal
        show={modalValidateShow}
        message={validdateData}
        onHide={() => setModalValidateShow(false)}
      />
    </>
  );
};
